import { MenuInterface } from '@biorec/common';
import { MenuItem } from 'primeng/api/menuitem';
import { Injectable } from '@angular/core';

@Injectable()
export class Menu implements MenuInterface {
	getMenu(): MenuItem[] {
		return (
			[
				{ label: $localize `Dashboard`, icon: 'mdi mdi-view-dashboard', routerLink: ['/dashboard'] },
				{ label: $localize `Personal Information`, icon: 'mdi mdi-card-account-details', routerLink: ['/personalInfo'] },
				// { label: $localize `Referrals Requests`, icon: 'mdi mdi-text-box-outline', routerLink: ['/referralsRequests'] },
				{ label: $localize `Referrals & Exams`, icon: 'mdi mdi-microscope', routerLink: ['/referrals'] },
				{ label: $localize `My patients`, icon: 'mdi mdi-account-box-multiple', routerLink: ['/my-patients'] },
//				{ label: $localize `My consumables`, icon: 'mdi mdi mdi-paperclip', routerLink: ['/my-inventory'] },
				{ label: $localize `EOPYY Instructions`, icon: 'mdi mdi-message-reply-text', routerLink: ['/instructions'] },
				{ label: $localize `Invoices`, icon: 'mdi mdi-file-percent', routerLink: ['/invoices'] }
			]
		);
	}

}

